export enum ToastMode {
  Standard = '',
  Success = 'bg-success text-light',
  Danger = 'bg-danger text-light'
}
